import React from "react";
import { Content, useTranslator } from "@sia/style-guide";
import Page from "../Page";

const PermissionDeniedPage = () => {
  const translate = useTranslator();
  return (
    <Page>
      <Content>
        <h1>{translate("routing.page.permission-denied.title")}</h1>
        <p>{translate("routing.page.permission-denied.text")}</p>
      </Content>
    </Page>
  );
};
export default PermissionDeniedPage;
